import React, { Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux'
import {
    ObtenerClientePorLogin41,
    actualizarFC_41PaginaActiva,
    registrarSolicitudFC_41Accion,
    obtenerContadorDeFechaFolio,
    actualizarFC_41Solicitud,
    actualizarFC_41Estatus,
    resetDataFC_41,
    agregarFC_41SolicitudBorrador,
    eliminarFC_41AnexoProductoBD,
    agregarFC_41AnexoProducto,
    actualizarModoBorradorFC_41,
    guardarCambiosFC_41SolicitudBorrador,
    guardarCambiosFC_41SolicitudNueva,
    agregarFC_41Producto,
    editarFC_41AnexoProductoBeneficiario,
    actualizarModoCorrecionFC_41
} from '../../../redux/DucksBeneficiario/FC_41Ducks'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import moment from 'moment'
import ToolBarPaginas from '../../App/ToolBarPaginas';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import estilos from './FormularioFC41BeneficiarioComponent.module.css';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
const { useState, useEffect, useRef } = React;
import InfoBar from '../../App/InfoBar'
import BotonAtrasSiguienteComponent from '../../App/BotonAtrasSiguienteComponent';
import TerminosYCondicionesComponent from '../../App/TerminosYCondicionesComponent';
import { Formik } from 'formik'
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { obtenerSolicitudesWithStatus } from '../../../redux/SolicitudesDucks';
//import DocumentacionFC_40Component from './DocumentacionFC_40Component';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import TablaProducto from './TablaProducto';
import DocumentacionFC_41Component from './DocumentacionFC_41Component';
import { obtenerColoniasPorCpApi, obtenerCPsPorMunicipioApi, obtenerEstadosApi, obtenerLocalidadesPorEstadoYMunicipioApi, obtenerCallesPorClavesEstadoMunicipioLocalidad, obtenerEstadosConClaveApi, obtenerMunicipiosConClavePorEstadoApi } from '../../../redux/DucksApis/CopomexDucks';

import Tooltip from '@mui/material/Tooltip';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function FormularioFC41BeneficiarioComponent(props) {
    const dispatch = useDispatch()

    var fechaHoy = moment().format('YYYY-MM-DD');
    let fc_41 = useSelector(store => store.FC_41Solicitud.fc_41)
    let fc_41Productos = useSelector(store => store.FC_41Solicitud.productos)
    let fc_41Map = useSelector(store => store.FC_41Solicitud.fc_41Map)
    let fc_41ProductosMap = useSelector(store => store.FC_41Solicitud.productosMap)
    const modoEdicionBorrador = useSelector(store => store.FC_41Solicitud.modoEdicionBorrador)
    const modoCorreccion = useSelector(store => store.FC_41Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_41Solicitud.data)
    let marcas = useSelector(store => store.FC_41Solicitud.marcas)
    const usuario = useSelector(store => store.Usuario)
    const idUsuario = usuario.data.user[0].id
    let dataCliente = useSelector(store => store.FC_41Solicitud.cliente)
    let dataLogin = useSelector(store => store.FC_41Solicitud.dataLogin)
    let instalacionesCliente = useSelector(store => store.FC_41Solicitud.instalacionesCliente)

    /*COPOMEX API*/
    const estadosApi = useSelector(store => store.CopomexApi.estados)
    const municipiosApi = useSelector(store => store.CopomexApi.municipios)
    const codigosPostalesApi = useSelector(store => store.CopomexApi.codigosPostales)
    const coloniasApi = useSelector(store => store.CopomexApi.colonias)
    const localidadesApi = useSelector(store => store.CopomexApi.localidades)
    const callesApi = useSelector(store => store.CopomexApi.calles)


    React.useEffect(() => {
        let data = dispatch(ObtenerClientePorLogin41({ idlogin: usuario.data.user[0].id }))
        dispatch(obtenerEstadosConClaveApi())
    }, [])
    const obtenerCodigosPostales = async (municipio) => {
        //get Codigos Postales por municipio
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerCPsPorMunicipioApi(municipio))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerColonias = async (cp) => {
        //get colonia por CP
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerColoniasPorCpApi(cp))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerLocalidades = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerLocalidadesPorEstadoYMunicipioApi({ estado: data.estado, municipio: data.municipio }))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }

    const obtenerCalles = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const clave_estado = await obtenerClaveDomicilioEstado(estadosApi, data.clave_estado)
        const clave_municipio = await obtenerClaveDomicilio(municipiosApi, data.clave_municipio, "municipio")
        const clave_localidad = await obtenerClaveDomicilio(localidadesApi, data.clave_localidad, "localidad")
        const result = await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({ clave_estado: clave_estado, clave_municipio: clave_municipio, clave_localidad: clave_localidad }))
        await dispatch(actualizarLoadingApp_false())
        // await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({clave_estado: data.clave_estado, clave_municipio: data.clave_municipio, clave_localidad: data.clave_localidad}))
        return result.payload
    }
    const obtenerClaveDomicilioEstado = async (array, key) => {
        for (const i in array) {
            if (array[i][0] === key) return array[i][1]
        }
    }
    const obtenerClaveDomicilio = async (array, key, nombre) => {
        for (const i in array) {
            if (array[i][nombre] === key) return array[i]["clave"]
        }
    }

    const obtenerEstadosConClave = async () => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerEstadosConClaveApi())
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerMunicipiosConClave = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerMunicipiosConClavePorEstadoApi(data))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    let [terminosYCondiciones, setTerminosYCondiciones] = useStateIfMounted(false)
    const currentUser = useSelector(store => store.Usuario.data)

    React.useEffect(() => {
        if (props.history.location.state) {
            setTerminosYCondiciones(props.history.location.state.terminosYCondiciones)
        }
    }, [props.history.location.state])

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [paginas, setPaginas] = useStateIfMounted([1, 2, 3])
    const paginaActiva = useSelector(store => store.FC_41Solicitud.paginaActiva)
    const paginaSiguiente = async (valores) => {
        const result = await validation(valores)
        if (JSON.stringify(result) !== '{}') {
            settexto('')
            setvalidacion(true)
        } else {
            dispatch(actualizarFC_41PaginaActiva(paginaActiva + 1))
        }
    }
    const paginaAnterior = async () => {
        dispatch(actualizarFC_41PaginaActiva(paginaActiva - 1))
    }
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    const [nombre, setnombre] = useStateIfMounted('')
    const [domicilio, setdomicilio] = useStateIfMounted('')
    const [paisdestino, setpaisdestino] = useStateIfMounted('')
    const [aduanasalida, setaduanasalida] = useStateIfMounted('')
    const [observaciones, setobservaciones] = useStateIfMounted('')
    const [ventaexportacion, setventaexportacion] = useStateIfMounted(false)
    const [idfc41_solicitudparabebidasconm, setidfc41_solicitudparabebidasconm] = useStateIfMounted(0)
    const [idlogin, setidlogin] = useStateIfMounted(idUsuario)

    const [productos, setProductos] = React.useState([])
    const handdleProducto = (objectProducto) => {
        setProductos(prev => [...prev, objectProducto])
    }
    const handdleRemoveProductosPrev = async (objectProducto) => {
        if (objectProducto.data.idfc41_anexoproducto) {
            await dispatch(eliminarFC_41AnexoProductoBD(objectProducto.data.idfc41_anexoproducto))
        }
        const filtro = productos.filter(anexo => anexo.id !== objectProducto.data.id)
        setProductos(filtro)
    }
    const handdleEditProductosPrev = (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (fc_41ProductosMap.length > 0) {
            const filtro = productos.findIndex(anexo => anexo.idfc41_anexoproducto === objectProducto.id)
            let editar = { ...productos[Number(filtro)] }
            const newProductos = []
            for (const i in productos) {
                const { ...restProducto } = productos[i]
                newProductos.push(restProducto)
            }
            const filtroEliminar = productos.filter(anexo => anexo.idfc41_anexoproducto !== objectProducto.id)
            newProductos[Number(filtro)].contenidoalcoholico = objectProducto.contenidoalcoholico
            newProductos[Number(filtro)].numeroanalisisgranel = objectProducto.numeroanalisisgranel
            newProductos[Number(filtro)].numerocertificado = objectProducto.numerocertificado
            newProductos[Number(filtro)].marca = objectProducto.marca
            newProductos[Number(filtro)].numerolote = objectProducto.numerolote
            newProductos[Number(filtro)].numerolotegranel = objectProducto.numerolotegranel
            newProductos[Number(filtro)].contenidonetobotella = objectProducto.contenidonetobotella
            newProductos[Number(filtro)].numerobotellas = objectProducto.numerobotellas
            newProductos[Number(filtro)].numerocajas = objectProducto.numerocajas
            newProductos[Number(filtro)].numeroanalisisbebida = objectProducto.numeroanalisisbebida
            newProductos[Number(filtro)].tipobebida = objectProducto.tipobebida
            newProductos[Number(filtro)].ingrediente = objectProducto.ingrediente
            /*editar.contenidoalcoholico = objectProducto.contenidoalcoholico
            editar.numeroanalisisgranel = objectProducto.numeroanalisisgranel
            editar.numerocertificado = objectProducto.numerocertificado
            editar.marca = objectProducto.marca
            editar.numerolote = objectProducto.numerolote
            editar.numerolotegranel = objectProducto.numerolotegranel
            editar.contenidonetobotella = objectProducto.contenidonetobotella
            editar.numerobotellas = objectProducto.numerobotellas
            editar.numerocajas = objectProducto.numerocajas
            editar.numeroanalisisbebida = objectProducto.numeroanalisisbebida
            editar.tipobebida = objectProducto.tipobebida
            editar.ingrediente = objectProducto.ingrediente*/
            filtroEliminar.push(editar)
            setProductos(newProductos)
        } else {
            const filtro = productos.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = productos
            const newProductos = []
            for (const i in productos) {
                const { ...restProducto } = productos[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].contenidoalcoholico = objectProducto.contenidoalcoholico
            newProductos[Number(filtro)].numeroanalisisgranel = objectProducto.numeroanalisisgranel
            newProductos[Number(filtro)].numerocertificado = objectProducto.numerocertificado
            newProductos[Number(filtro)].marca = objectProducto.marca
            newProductos[Number(filtro)].numerolote = objectProducto.numerolote
            newProductos[Number(filtro)].numerolotegranel = objectProducto.numerolotegranel
            newProductos[Number(filtro)].contenidonetobotella = objectProducto.contenidonetobotella
            newProductos[Number(filtro)].numerobotellas = objectProducto.numerobotellas
            newProductos[Number(filtro)].numerocajas = objectProducto.numerocajas
            newProductos[Number(filtro)].numeroanalisisbebida = objectProducto.numeroanalisisbebida
            newProductos[Number(filtro)].tipobebida = objectProducto.tipobebida
            newProductos[Number(filtro)].ingrediente = objectProducto.ingrediente
            setProductos(newProductos)
        }
    }

    const store = useSelector(store => store)

    const noActualizarBorrador = useRef(true)
    React.useEffect(() => {
        if (!(JSON.stringify({}) === JSON.stringify(data))) {
            fc_41 = data
        }
        if (!(JSON.stringify({}) == JSON.stringify(fc_41))) {

            if (fc_41Productos.data) {
                if (fc_41Productos.data.data) {
                    setProductos(fc_41Productos.data.data)
                } else {
                    setProductos(fc_41Productos.data)
                }
            }
            let fechasolicitud = moment(fc_41.fechasolicitud).format('YYYY-MM-DD')
            let fechavisitapropuesta = moment(fc_41.fechasolicitud).format('YYYY-MM-DD')
        }
    }, [fc_41, data])

    React.useEffect(() => {
        if (fc_41Productos.data) {
            if (fc_41Productos.data.data) {
                setProductos(fc_41Productos.data.data)
            } else {
                setProductos(fc_41Productos.data)
            }
        }
    }, [fc_41Productos])

    let botonEnviarRegistro = false
    let botonEnviarBorrador = false
    const [botonEnviarCorrecciones, setBotonEnviarCorrecciones] = React.useState(false)
    const [functionResetForm, setFunctionResetForm] = React.useState()
    const [functionSubmitForm, setFunctionSubmitForm] = React.useState()

    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModal = (data) => {

        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
        setDataModal(data.data)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        setDataModal('')
    }

    const modalComponent = () => {
        return (
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        <center>{titleModal}</center>
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }} component="h2">
                        <p className={`${estilos.bodyModal}`}>{bodyModal}</p> <br /> <center><strong>¿Desea continuar?</strong></center>
                    </Typography><br />
                    <div className='row'>
                        <button className='btn btn-success' onClick={() => {
                            switch (accion) {
                                case 'guardarBorrador':
                                    guardarBorrador(dataModal)
                                    break;
                                case 'actualizarBorrador':
                                    actualizarBorrador(dataModal)
                                    break;
                                case 'enviarSolicitudFC_41':
                                    activarBotonEnviarForm()
                                    functionSubmitForm.function()
                                    break;
                                case 'enviarSolicitudBorradorFC_41':
                                    activarBotonEnviarBorrador()
                                    functionSubmitForm.function()
                                    break;

                                case 'enviarBorrador':
                                    enviarBorrador()
                                    break;
                                case 'reiniciarFormato':
                                    handleResetAllPropertys()
                                    break;
                                case 'enviarCorreccion':
                                    activarBotonEnviarCorreciones()
                                    functionSubmitForm.function()
                                    break;
                                default:
                                    break;
                            }
                        }}>CONTINUAR</button>
                    </div>
                </Box>
            </Modal>
        )
    }
    const activarBotonEnviarCorreciones = () => {
        setBotonEnviarCorrecciones(true)
    }
    const handleResetAllPropertys = () => {
        dispatch(resetDataFC_41())
        //productos([])
        handleCloseModal()
    }
    const activarBotonEnviarForm = () => {
        botonEnviarRegistro = true
    }
    const activarBotonEnviarBorrador = () => {
        botonEnviarBorrador = true
    }
    const botonGuardarComoBorrador = async (valores) => {
        if (modoEdicionBorrador) {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de actualizar este borrador de solicitud.
                Los archivos de la sección final no se guardarán, puesto que es un borrador del formulario.`,
                accion: 'actualizarBorrador',
                data: valores
            })
        } else {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de guardar esta solicitud en su apartado de borradores.
                Los archivos de la sección final no se guardarán puesto que es un borrador del formulario.`,
                accion: 'guardarBorrador',
                data: valores
            })
        }
    }
    const botonEnviarSolicitudFC_41 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudFC_41'
        })
    }
    const botonEnviarSolicitudBorradorFC_41 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudBorradorFC_41'
        })
    }



    const botonReiniciarFormato = () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de reiniciar el formato, esta acción eliminará toda la información
                y no se podrá revertir.`,
            accion: 'reiniciarFormato'
        })
    }
    const botonEnviarCorreccionesFC_41 = async () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de enviar las correcciones al personal de atención al cliente, 
            ya no podrá seguir corrigiendo esta solicitud.`,
            accion: 'enviarCorreccion'
        })
    }

    const guardarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio

        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechavisitapropuesta = new Date(valores.fechavisitapropuesta).toISOString()
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))

        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 99999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio
        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones,
            correoelectronico: valores.correoelectronico, telefono: valores.telefono, domicilio: valores.domicilio,
            entregahologramasbebidasmezcal: valores.entregahologramasbebidasmezcal, emicioncertificadonomexportacio: valores.emicioncertificadonomexportacio,
            inspeccionduranteenvasado: valores.inspeccionduranteenvasado, emicioncertificadonomnacional: valores.emicioncertificadonomnacional,
            fechavisitapropuesta: fechavisitapropuesta, ventaexportacion: valores.ventaexportacion, ventanacional: valores.ventanacional,
            nombreimportador: valores.nombreimportador, domicilioimportador: valores.domicilioimportador, paisdestino: valores.paisdestino,
            aduanasalida: valores.aduanasalida, observaciones: valores.observaciones,
            idestatusdesolicitudes: 1, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
            estado: valores.estado, municipioalcaldia: valores.municipioalcaldia, codigopostal: valores.codigopostal,
            colonia: valores.colonia, localidad: valores.localidad, otracalle: valores.otracalle, calle: valores.calle,
            numeroexterior: valores.numeroexterior, numerointerior: valores.numerointerior
        }
        let objetoCompleto = {
            solicitud: solicitud, productos: productos
        }
        const resultado = await dispatch(registrarSolicitudFC_41Accion(objetoCompleto))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_41())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const actualizarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())

        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechavisitapropuesta = new Date(valores.fechavisitapropuesta).toISOString()

        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc41_solicitudparabebidasconm: data.idfc41_solicitudparabebidasconm,
            tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones,
            correoelectronico: valores.correoelectronico, telefono: valores.telefono, domicilio: valores.domicilio,
            entregahologramasbebidasmezcal: valores.entregahologramasbebidasmezcal, emicioncertificadonomexportacio: valores.emicioncertificadonomexportacio,
            inspeccionduranteenvasado: valores.inspeccionduranteenvasado, emicioncertificadonomnacional: valores.emicioncertificadonomnacional,
            fechavisitapropuesta: fechavisitapropuesta, ventaexportacion: valores.ventaexportacion, ventanacional: valores.ventanacional,
            nombreimportador: valores.nombreimportador, domicilioimportador: valores.domicilioimportador, paisdestino: valores.paisdestino,
            aduanasalida: valores.aduanasalida, observaciones: valores.observaciones,
            idestatusdesolicitudes: 1,
            estado: valores.estado, municipioalcaldia: valores.municipioalcaldia, codigopostal: valores.codigopostal,
            colonia: valores.colonia, localidad: valores.localidad, otracalle: valores.otracalle, calle: valores.calle,
            numeroexterior: valores.numeroexterior, numerointerior: valores.numerointerior
        }
        const objetoCompleto = { solicitud: solicitud, productos: productos }
        const resultado = await dispatch(actualizarFC_41Solicitud(objetoCompleto))

        await dispatch(actualizarLoadingApp_false())
        await dispatch(resetDataFC_41())
        await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
        props.history.push('/solicitudes')
    }
    const botonRegistrarFC_41 = async (valores) => {
        await dispatch(actualizarLoadingApp_true())

        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))
        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 99999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        let fechavisitapropuesta = new Date(valores.fechavisitapropuesta).toISOString()
        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones,
            correoelectronico: valores.correoelectronico, telefono: valores.telefono, domicilio: valores.domicilio,
            entregahologramasbebidasmezcal: valores.entregahologramasbebidasmezcal, emicioncertificadonomexportacio: valores.emicioncertificadonomexportacio,
            inspeccionduranteenvasado: valores.inspeccionduranteenvasado, emicioncertificadonomnacional: valores.emicioncertificadonomnacional,
            fechavisitapropuesta: fechavisitapropuesta, ventaexportacion: valores.ventaexportacion, ventanacional: valores.ventanacional,
            nombreimportador: valores.nombreimportador, domicilioimportador: valores.domicilioimportador, paisdestino: valores.paisdestino,
            aduanasalida: valores.aduanasalida, observaciones: valores.observaciones,
            idestatusdesolicitudes: 7, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
            estado: valores.estado, municipioalcaldia: valores.municipioalcaldia, codigopostal: valores.codigopostal,
            colonia: valores.colonia, localidad: valores.localidad, otracalle: valores.otracalle, calle: valores.calle,
            numeroexterior: valores.numeroexterior, numerointerior: valores.numerointerior
        }
        let objetoCompleto = {
            solicitud: solicitud, productos: productos
        }
        const resultado = await dispatch(registrarSolicitudFC_41Accion(objetoCompleto))
        await dispatch(actualizarLoadingApp_false())
        await dispatch(resetDataFC_41())
        functionResetForm.function()
        await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
        props.history.push('/solicitudes')
    }

    const enviarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechavisitapropuesta = new Date(valores.fechavisitapropuesta).toISOString()

        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc41_solicitudparabebidasconm: data.idfc41_solicitudparabebidasconm,
            tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones,
            correoelectronico: valores.correoelectronico, telefono: valores.telefono, domicilio: valores.domicilio,
            entregahologramasbebidasmezcal: valores.entregahologramasbebidasmezcal, emicioncertificadonomexportacio: valores.emicioncertificadonomexportacio,
            inspeccionduranteenvasado: valores.inspeccionduranteenvasado, emicioncertificadonomnacional: valores.emicioncertificadonomnacional,
            fechavisitapropuesta: fechavisitapropuesta, ventaexportacion: valores.ventaexportacion, ventanacional: valores.ventanacional,
            nombreimportador: valores.nombreimportador, domicilioimportador: valores.domicilioimportador, paisdestino: valores.paisdestino,
            aduanasalida: valores.aduanasalida, observaciones: valores.observaciones,
            idestatusdesolicitudes: 7,
            estado: valores.estado, municipioalcaldia: valores.municipioalcaldia, codigopostal: valores.codigopostal,
            colonia: valores.colonia, localidad: valores.localidad, otracalle: valores.otracalle, calle: valores.calle,
            numeroexterior: valores.numeroexterior, numerointerior: valores.numerointerior
        }
        const objetoCompleto = { solicitud: solicitud, productos: productos }
        const resultado = await dispatch(actualizarFC_41Solicitud(objetoCompleto))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            const idSolicitud = data.idfc41_solicitudparabebidasconm
            const estatusNuevo = 7
            const idCliente = dataCliente.idcliente//null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_41 = 12
            const tabla = tablaFC_41
            await dispatch(actualizarFC_41Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_41())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const enviarCorreccion = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechavisitapropuesta = new Date(valores.fechavisitapropuesta).toISOString()

        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc41_solicitudparabebidasconm: data.idfc41_solicitudparabebidasconm,
            tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones,
            correoelectronico: valores.correoelectronico, telefono: valores.telefono, domicilio: valores.domicilio,
            entregahologramasbebidasmezcal: valores.entregahologramasbebidasmezcal, emicioncertificadonomexportacio: valores.emicioncertificadonomexportacio,
            inspeccionduranteenvasado: valores.inspeccionduranteenvasado, emicioncertificadonomnacional: valores.emicioncertificadonomnacional,
            fechavisitapropuesta: fechavisitapropuesta, ventaexportacion: valores.ventaexportacion, ventanacional: valores.ventanacional,
            nombreimportador: valores.nombreimportador, domicilioimportador: valores.domicilioimportador, paisdestino: valores.paisdestino,
            aduanasalida: valores.aduanasalida, observaciones: valores.observaciones,
            idestatusdesolicitudes: 6,
            estado: valores.estado, municipioalcaldia: valores.municipioalcaldia, codigopostal: valores.codigopostal,
            colonia: valores.colonia, localidad: valores.localidad, otracalle: valores.otracalle, calle: valores.calle,
            numeroexterior: valores.numeroexterior, numerointerior: valores.numerointerior
        }
        const objetoCompleto = { solicitud: solicitud, productos: productos }
        const resultado = await dispatch(actualizarFC_41Solicitud(objetoCompleto))
        const idSolicitud = data.idfc41_solicitudparabebidasconm
        const estatusNuevo = 6
        const idCliente = null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_41 = 12
        const tabla = tablaFC_41
        await dispatch(actualizarFC_41Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
        ))
        await dispatch(resetDataFC_41())
        handleResetAllPropertys()
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/solicitudes')
    }
    const setDatos = (datos) => {
        let dato = datos.split('/')
        let idanexocliente = Number(dato[1])
        let tipoanexo = Number(dato[0])
        for (let dato in instalacionesCliente) {
            if (instalacionesCliente?.[dato]?.idanexocliente === idanexocliente && instalacionesCliente?.[dato]?.idtipoanexo === tipoanexo) {
                const telefono = instalacionesCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[0].telefono
                const correoelectronico = instalacionesCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[0].correoelectronico
                const responsableinstalaciones = instalacionesCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[0].nombreresponsable
                let numeroint = ''
                let numeroext = ''
                if (instalacionesCliente[dato].informaciongeneralinstalacioncliente.numerointerior === null ||
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.numerointerior === undefined ||
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.numerointerior === '') numeroint = 's/n'
                else { numeroint = instalacionesCliente[dato].informaciongeneralinstalacioncliente.numerointerior }
                if (instalacionesCliente[dato].informaciongeneralinstalacioncliente.numeroexterior === null ||
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.numeroexterior === undefined ||
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.numeroexterior === '') numeroext = 's/n'
                else { numeroext = instalacionesCliente[dato].informaciongeneralinstalacioncliente.numeroexterior }
                const domicilio = instalacionesCliente[dato].informaciongeneralinstalacioncliente.calle + ',' +
                    numeroint + ',' + numeroext + ',' +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.colonia + ',' +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.localidad + ',' +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.municipio + ',' +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.estado + ',' +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.codigopostal
                return { responsableinstalaciones, telefono, correoelectronico, domicilio }
            }
        }
        return { responsableinstalaciones: '', telefono: '', correoelectronico: '', domicilio: '' }
    }
    const validation = values => {
        let errores = {};
        const textoCheck = 'Debe de seleccionar al menos una opción'
        const textoChecks = 'Debe de seleccionar solo una opción'
        const texto = 'Campo Obligatorio'
        if (paginaActiva === 1) {
            if (!values.tipoinstalacion) { errores.tipoinstalacion = texto }
            if (!values.responsableinstalaciones) { errores.responsableinstalaciones = texto }
            if (!values.correoelectronico) { errores.correoelectronico = texto }
            if (!values.telefono) { errores.telefono = texto }
            //if (!values.domicilio) { errores.domicilio = texto }
            if (!values.emicioncertificadonomexportacio && !values.emicioncertificadonomnacional) { errores.actividad = textoCheck }
        }
        if (paginaActiva === 2) {
            if (!values.ventanacional && !values.ventaexportacion) { errores.venta = textoCheck }
            if (values.ventanacional && values.ventaexportacion) { errores.venta = textoChecks }
            if (productos.length <= 0) { errores.productos = 'Debe de agregar por lo menos un producto' }
            if (values.ventaexportacion) {
                if (!values.nombreimportador) { errores.nombreimportador = texto }
                if (!values.domicilioimportador) { errores.domicilioimportador = texto }
                if (!values.paisdestino) { errores.paisdestino = texto }
                if (!values.aduanasalida) { errores.aduanasalida = texto }
                if (!values.observaciones) { errores.observaciones = texto }
            }

        }
        return errores;
    }
    return (
        <Fragment>
            <Formik
                initialValues={
                    fc_41
                }
                validate={validation}
                onSubmit={(valores) => {
                    if (botonEnviarRegistro) {
                        botonRegistrarFC_41(valores)
                    }
                    if (botonEnviarBorrador) {
                        enviarBorrador(valores)
                    }
                    if (botonEnviarCorrecciones) {
                        enviarCorreccion(valores)
                    }
                }}>
                {({ values, handleChange, handleSubmit, handleBlur, errors, touched, resetForm, submitForm, setValues }) => (
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className='container2'>
                            <div className='row mt-3'>
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-12 marginsitoTop">
                                    <InfoBar nombreSolicitud={'Solicitud de bebidas con mezcal'} />
                                </div>
                                {!modoCorreccion &&
                                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center marginsitoTop">
                                        <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                            aria-label="Guardar cambios" aria-haspopup="true" onClick={() =>
                                                botonGuardarComoBorrador(values)} >
                                            <SaveIcon />
                                            {modoEdicionBorrador ? (
                                                <div className="badge text-dark textoNormal textoModal">
                                                    Guardar cambios en borrador
                                                </div>) : (
                                                <div className="badge text-dark textoNormal textoModal">
                                                    Guardar como borrador
                                                </div>
                                            )}
                                        </IconButton>
                                    </div>
                                }
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-center">
                                    <h1></h1>
                                </div>
                                {!modoCorreccion &&
                                    <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 text-center marginsitoTop">
                                        <Fragment>
                                            <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                aria-label="Reiniciar formato" aria-haspopup="true" color="error" onClick={() =>
                                                    botonReiniciarFormato()}
                                            >
                                                <FormatClearIcon />
                                                <div className="badge text-dark textoNormal textoModal">Reiniciar Formato </div>
                                            </IconButton>
                                        </Fragment>
                                    </div>
                                }
                            </div>
                            {paginaActiva === 1 ?
                                <Fragment>
                                    <div className='row'>
                                        <h6 className={`text-center ${estilos.labelNaranja}`}>INFORMACIÓN DEL SOLICITANTE</h6>
                                    </div>
                                    <div className='row justify-content-start'>
                                        <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                                            <div className="form-floating mb-3">
                                                <select className={`form-select ${fc_41Map.tipoinstalacioncheck !== undefined ? (
                                                    fc_41Map?.tipoinstalacioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    name="especificaraduana"
                                                    value={values.tipoinstalacion}
                                                    onChange={e => {
                                                        const result = setDatos(e.target.value)
                                                        const { ...newValues } = values
                                                        //const cortar = e.target.value.split('/')
                                                        newValues.tipoinstalacion = e.target.value
                                                        if (result !== '') {
                                                            newValues.responsableinstalaciones = result.responsableinstalaciones
                                                            newValues.correoelectronico = result.correoelectronico
                                                            newValues.telefono = result.telefono
                                                            newValues.domicilio = result.domicilio
                                                        }
                                                        setValues(newValues)
                                                    }}
                                                    onBlur={handleBlur} >
                                                    <option value="0" >Tipo de instalación</option>
                                                    {instalacionesCliente?.map((opcion, index) => (
                                                        <option value={`${opcion.idtipoanexo === 1 ? opcion.idtipoanexo + '/' + opcion.idanexocliente : opcion.idtipoanexo === 2 ? opcion.idtipoanexo + '/' + opcion.idanexocliente : opcion.idtipoanexo === 3 ? opcion.idtipoanexo + '/' + opcion.idanexocliente : 'Domicilio Fiscal'}`} >
                                                            {`${opcion.idtipoanexo === 1 ? 'Unidad Producción: ' + opcion.informaciongeneralinstalacioncliente.alias : opcion.idtipoanexo === 2 ? 'Unidad Envasado: ' + opcion.informaciongeneralinstalacioncliente.alias : opcion.idtipoanexo === 3 ? 'Unidad Almacén: ' + opcion.informaciongeneralinstalacioncliente.alias : 'Domicilio Fiscal'}`}</option>
                                                    ))
                                                    }
                                                    <option value="Otro" >Otro</option>
                                                </select>
                                                <label htmlFor='floatingInput'></label>
                                                <span className='text-danger'>{fc_41Map?.tipoinstalacioncheck ? fc_41Map?.tipoinstalacion : ''}</span>
                                                <span className='text-danger'>NOTA: En caso de que su envasadora no se encuentre registrada, favor de agregar el domicilio de su maquilador.</span>
                                                {touched.tipoinstalacion && errors.tipoinstalacion && <div className="text-danger">{errors.tipoinstalacion}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                            <div className="form-floating mb-3">
                                                <input type="text" className={`form-control ${fc_41Map.responsableinstalacionescheck !== undefined ? (
                                                    fc_41Map?.responsableinstalacionescheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='responsable'
                                                    name="responsableinstalaciones"
                                                    value={values.responsableinstalaciones}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label htmlFor='floatingInput'>Nombre de responsable</label>
                                                <span className='text-danger'>{fc_41Map?.responsableinstalacionescheck ? fc_41Map?.responsableinstalaciones : ''}</span>
                                                {touched.responsableinstalaciones && errors.responsableinstalaciones && <div className="text-danger">{errors.responsableinstalaciones}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                            <div className="form-floating mb-3">
                                                <input type="text" className={`form-control ${fc_41Map.correoelectronicocheck !== undefined ? (
                                                    fc_41Map?.correoelectronicocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='responsable'
                                                    name="correoelectronico"
                                                    value={values.correoelectronico}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label htmlFor='floatingInput'>Correo Electrónico</label>
                                                <span className='text-danger'>{fc_41Map?.correoelectronicocheck ? fc_41Map?.correoelectronico : ''}</span>
                                                {touched.correoelectronico && errors.correoelectronico && <div className="text-danger">{errors.correoelectronico}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                            <div className="form-floating mb-3">
                                                <input type="number" className={`form-control ${fc_41Map.telefonocheck !== undefined ? (
                                                    fc_41Map?.telefonocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='telefono'
                                                    name="telefono"
                                                    value={values.telefono}
                                                    onChange={e => {
                                                        const { ...newValues } = values
                                                        newValues.telefono = e.target.value
                                                        setValues(newValues)
                                                    }}
                                                    onBlur={handleBlur}
                                                    onWheel={event => event.currentTarget.blur()}
                                                />
                                                <label htmlFor='floatingInput'>Teléfono</label>
                                                <span className='text-danger'>{fc_41Map?.telefonocheck ? fc_41Map?.telefono : ''}</span>
                                                {touched.telefono && errors.telefono && <div className="text-danger">{errors.telefono}</div>}
                                            </div>
                                        </div>
                                        {values.tipoinstalacion != 'Otro' && <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <div className="form-floating mb-3">
                                                <input type="text" className={`form-control ${fc_41Map.domiciliocheck !== undefined ? (
                                                    fc_41Map?.domiciliocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='domicilio'
                                                    name="domicilio"
                                                    value={values.domicilio}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label htmlFor='floatingInput'>Domicilio completo</label>
                                                <span className='text-danger'>{fc_41Map?.domiciliocheck ? fc_41Map?.domicilio : ''}</span>
                                                {touched.domicilio && errors.domicilio && <div className="text-danger">{errors.domicilio}</div>}
                                            </div>
                                        </div>}
                                        {values.tipoinstalacion == 'Otro' &&
                                            <Fragment>
                                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <div className="form-floating mb-3">

                                                        <select className={`form-control ${fc_41Map.domiciliocheck !== undefined ? (
                                                            fc_41Map?.domiciliocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            value={values.estado}
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.estado = e.target.value
                                                                newValues.municipioalcaldia = ''
                                                                newValues.codigopostal = ''
                                                                newValues.colonia = ''
                                                                newValues.localidad = ''
                                                                newValues.calle = ''
                                                                if (e.target.value !== '') obtenerMunicipiosConClave(e.target.value)
                                                                setValues(newValues)

                                                            }}
                                                            name="estado"
                                                            onBlur={handleBlur}
                                                        >
                                                            <option value="">Seleccione su estado</option>
                                                            {
                                                                estadosApi?.[0] !== undefined && estadosApi?.map((estado, index) => (
                                                                    <option key={index} value={`${estado[0]}`}>{`${estado[0]}`}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {touched.estado && errors.estado && <div className="text-danger">{errors.estado}</div>}
                                                        <span className={` ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                            ? 'text-danger' : 'text-success') : ('')}`} >{fc_41Map?.domiciliocheck
                                                                ? (fc_41Map?.domicilio) : ''}</span>
                                                        <label className='floatingInput'>Estado</label>
                                                    </div>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-control ${fc_41Map.domiciliocheck !== undefined ? (
                                                            fc_41Map?.domiciliocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            value={values.municipioalcaldia}
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.municipioalcaldia = e.target.value
                                                                newValues.codigopostal = ''
                                                                newValues.colonia = ''
                                                                newValues.localidad = ''
                                                                newValues.calle = ''
                                                                if (e.target.value !== '') obtenerCodigosPostales(e.target.value)
                                                                setValues(newValues)
                                                            }}
                                                            name="municipioalcaldia"
                                                            onBlur={handleBlur}
                                                            disabled={values.estado === '' ? true : false}
                                                        >
                                                            <option value="">Seleccione su municipio</option>
                                                            {
                                                                municipiosApi?.[0] !== undefined && municipiosApi?.map((municipio, index) => (
                                                                    <option key={index} value={`${municipio.municipio}`}>{`${municipio.municipio}`}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {touched.municipioalcaldia && errors.municipioalcaldia && <div className="text-danger">{errors.municipioalcaldia}</div>}
                                                        <span className={` ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                            ? 'text-danger' : 'text-success') : ('')}`} >{fc_41Map?.domiciliocheck ? (fc_41Map?.domicilio) : ''}</span>

                                                        <label className="label-dark" htmlFor="floatingInput">Municipio/Alcaldía</label>
                                                    </div>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-control ${fc_41Map.domiciliocheck !== undefined ? (
                                                            fc_41Map?.domiciliocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            value={values.codigopostal}
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.codigopostal = e.target.value
                                                                newValues.colonia = ''
                                                                newValues.localidad = ''
                                                                newValues.calle = ''
                                                                if (e.target.value !== '') obtenerColonias(e.target.value)
                                                                if (e.target.value !== '') obtenerLocalidades({ estado: values.estado, municipio: values.municipioalcaldia })
                                                                setValues(newValues)
                                                            }}
                                                            name="codigopostal"
                                                            onBlur={handleBlur}
                                                            disabled={values.municipioalcaldia === '' ? true : false} >
                                                            <option value="">Seleccione su código postal</option>
                                                            {codigosPostalesApi?.[0] !== undefined && codigosPostalesApi?.map((cp, index) => (
                                                                <option key={index} value={`${cp}`}>{`${cp}`}</option>
                                                            ))
                                                            }
                                                        </select>
                                                        {touched.codigopostal && errors.codigopostal && <div className="text-danger">{errors.codigopostal}</div>}
                                                        <span className={` ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                            ? 'text-danger' : 'text-success') : ('')}`} >{fc_41Map?.domiciliocheck ? (fc_41Map?.domicilio) : ''}</span>

                                                        <label className="label-dark" htmlFor="floatingInput">Código Postal</label>
                                                    </div>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-control ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                            ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            value={values.colonia}
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.colonia = e.target.value
                                                                setValues(newValues)
                                                            }}
                                                            name="colonia"
                                                            onBlur={handleBlur}
                                                            disabled={values.codigopostal === '' ? true : false} >
                                                            <option value="">Seleccione su colonia</option>
                                                            {coloniasApi?.[0] !== undefined && coloniasApi?.map((colonia, index) => (
                                                                <option key={index} value={`${colonia}`}>{`${colonia}`}</option>
                                                            ))}
                                                        </select>
                                                        {touched.colonia && errors.colonia && <div className="text-danger">{errors.colonia}</div>}
                                                        <span className={` ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                            ? 'text-danger' : 'text-success') : ('')}`} >{fc_41Map?.domiciliocheck ? (fc_41Map?.domicilio) : ''}</span>

                                                        <label className="label-dark" htmlFor="floatingInput">Colonia</label>
                                                    </div>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-control ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                            ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            value={values.localidad}
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.localidad = e.target.value
                                                                newValues.calle = ''
                                                                if (e.target.value !== '') obtenerCalles({ clave_estado: values.estado, clave_municipio: values.municipioalcaldia, clave_localidad: values.localidad })

                                                                setValues(newValues)
                                                            }}
                                                            name="localidad"
                                                            onBlur={handleBlur}
                                                            disabled={values.codigopostal === '' ? true : false} >
                                                            <option value="">Seleccione su localidad</option>
                                                            {localidadesApi?.[0] !== undefined && localidadesApi?.map((localidad, index) => (
                                                                <option key={index} value={`${localidad.localidad}`}>{`${localidad.localidad}`}</option>
                                                            ))}
                                                        </select>
                                                        {touched.localidad && errors.localidad && <div className="text-danger">{errors.localidad}</div>}
                                                        <span className={` ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                            ? 'text-danger' : 'text-success') : ('')}`} >{fc_41Map?.domiciliocheck ? (fc_41Map?.domicilio) : ''}</span>

                                                        <label className="label-dark" htmlFor="floatingInput">Localidad</label>
                                                    </div>
                                                </div>
                                                <div className={`col-xs-12 col-sm-12 ${values.calle === 'Otro' ? 'col-md-1 col-lg-1 col-xl-1' : 'col-md-6 col-lg-6 col-xl-6'}`}>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-control ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                            ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            value={values.calle}
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.calle = e.target.value
                                                                setValues(newValues)
                                                            }}
                                                            name="calle"
                                                            onBlur={handleBlur}
                                                            disabled={values.localidad === '' ? true : false} >
                                                            <option value="">Seleccione su calle</option>
                                                            {callesApi?.[0] !== undefined && callesApi?.map((calle, index) => (
                                                                <option key={index} value={`${calle.nombre_vialidad}`}>{`${calle.nombre_vialidad}`}</option>
                                                            ))}
                                                            <option value="Otro">Otro</option>
                                                        </select>
                                                        {touched.calle && errors.calle && <div className="text-danger">{errors.calle}</div>}
                                                        <span className={` ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                            ? 'text-danger' : 'text-success') : ('')}`} >{fc_41Map?.domiciliocheck ? (fc_41Map?.domicilio) : ''}</span>

                                                        <label className="label-dark" htmlFor="floatingInput">Calle</label>
                                                    </div>
                                                </div>
                                                {values.calle === 'Otro' &&
                                                    <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                                                        <div className="form-floating mb-3">
                                                            <input type="text" id="floatingInput"
                                                                className={`form-control ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                                    ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                placeholder='Calle'
                                                                name="otracalle"
                                                                value={values.otracalle}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur} />
                                                            {touched.otracalle && errors.otracalle && <div className="text-danger">{errors.otracalle}</div>}
                                                            <span className={` ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                                ? 'text-danger' : 'text-success') : ('')}`} >{fc_41Map?.domiciliocheck ? (fc_41Map?.domicilio) : ''}</span>

                                                            <label className="label-dark" htmlFor="floatingInput">Especifique</label>
                                                        </div>
                                                    </div>
                                                }
                                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <div className="form-floating mb-3">
                                                        <input type="text" id="floatingInput"
                                                            className={`form-control ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            placeholder='Número exterior'
                                                            name="numeroexterior" value={values.numeroexterior}
                                                            onChange={handleChange} onBlur={handleBlur} />
                                                        {touched.numeroexterior && errors.numeroexterior && <div className="text-danger">{errors.numeroexterior}</div>}
                                                        <span className={` ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                            ? 'text-danger' : 'text-success') : ('')}`} >{fc_41Map?.domiciliocheck ? (fc_41Map?.domicilio) : ''}</span>

                                                        <label className="label-dark" htmlFor="floatingInput">Número exterior</label>
                                                    </div>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <div className="form-floating mb-3">
                                                        <input type="text" className={`form-control ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                            ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            id="" placeholder='Número interior'
                                                            name="numerointerior" value={values.numerointerior}
                                                            onChange={handleChange} onBlur={handleBlur} />
                                                        {touched.numerointerior && errors.numerointerior && <div className="text-danger">{errors.numerointerior}</div>}
                                                        <span className={` ${fc_41Map.domiciliocheck !== undefined ? (fc_41Map?.domiciliocheck
                                                            ? 'text-danger' : 'text-success') : ('')}`} >{fc_41Map?.domiciliocheck ? (fc_41Map?.domicilio) : ''}</span>

                                                        <label className="label-dark" htmlFor="floatingInput">Número interior</label>
                                                    </div>
                                                </div>
                                            </Fragment>}
                                    </div>
                                    <div className='row'>
                                        <h6 className={`text-center ${estilos.labelNaranja}`}>SERVICIO SOLICITADO </h6>
                                    </div>
                                    <div className='row justify-content-start'>
                                        <div className={`row  ${estilos.divSoloBorderNaranja}`}>
                                            <small className='text-center'><b>Seleccione la actividad a notificar correspondiente</b></small>

                                            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-start mt-3'>
                                                <input className={`form-check-input ${fc_41Map.emicioncertificadonomexportaciocheck !== undefined ? (
                                                    fc_41Map?.emicioncertificadonomexportaciocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                    checked={values.emicioncertificadonomexportacio} id='emicioncertificadonomexportacio'
                                                    name="emicioncertificadonomexportacio"
                                                    onChange={e => {
                                                        const { ...newValues } = values
                                                        newValues.emicioncertificadonomexportacio = e.target.checked
                                                        if (e.target.checked) {
                                                            newValues.inspeccionduranteenvasado = true
                                                            newValues.ventaexportacion = true
                                                            newValues.ventanacional = false
                                                            newValues.emicioncertificadonomnacional = false
                                                        } else {
                                                            newValues.inspeccionduranteenvasado = false
                                                            newValues.ventaexportacion = false
                                                        }
                                                        setValues(newValues)
                                                    }}
                                                    onBlur={handleBlur} />
                                                <Tooltip title={`El certificado se emitirá una vez que se reciba el Dictamen de Cumplimiento con la
                                                    NOM de la Unidad de inspección (previa inspección del envasado y del holograma de
                                                    certificación).`} arrow>
                                                    <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                        Emisión del certificado NOM de exportación
                                                    </label>
                                                </Tooltip> <br />
                                                <span className='text-danger'>{fc_41Map?.emicioncertificadonomexportaciocheck === true ? fc_41Map?.emicioncertificadonomexportacio : ''}</span>
                                            </div>
                                            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-start mt-3'>
                                                <input className={`form-check-input ${fc_41Map.emicioncertificadonomnacionalcheck !== undefined ? (
                                                    fc_41Map?.emicioncertificadonomnacionalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                    checked={values.emicioncertificadonomnacional} id='emicioncertificadonomnacional'
                                                    name="emicioncertificadonomnacional"
                                                    onChange={e => {
                                                        const { ...newValues } = values
                                                        //newValues.produccionsuspencion = !e.target.checked
                                                        newValues.emicioncertificadonomnacional = e.target.checked
                                                        //newValues.certificadonomproductor = e.target.checked
                                                        if (e.target.checked) {
                                                            newValues.inspeccionduranteenvasado = true
                                                            newValues.ventanacional = true
                                                            newValues.ventaexportacion = false
                                                            newValues.emicioncertificadonomexportacio = false
                                                        } else {
                                                            newValues.inspeccionduranteenvasado = false
                                                            newValues.ventanacional = false
                                                        }
                                                        setValues(newValues)
                                                    }}
                                                    onBlur={handleBlur} />
                                                <Tooltip title={`El certificado se emitirá una vez que se reciba el Dictamen de Cumplimiento con la
                                                    NOM de la Unidad de inspección (previa inspección del envasado y del holograma de
                                                    certificación).`} arrow>
                                                    <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                        Emisión del certificado NOM para venta
                                                    </label>
                                                </Tooltip><br />
                                                <label className="ms-4">nacional</label>
                                                <span className='text-danger'>{fc_41Map?.emicioncertificadonomnacionalcheck === true ? fc_41Map?.emicioncertificadonomnacional : ''}</span>
                                            </div>
                                            {errors.actividad && <div className="text-danger">{errors.actividad}</div>}
                                            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-start mt-1'>
                                                <input className={`form-check-input ${fc_41Map.entregahologramasbebidasmezcalcheck !== undefined ? (
                                                    fc_41Map?.entregahologramasbebidasmezcalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                    checked={values.entregahologramasbebidasmezcal} id='entregahologramasbebidasmezcal'
                                                    name="entregahologramasbebidasmezcal"
                                                    onChange={e => {
                                                        const { ...newValues } = values
                                                        //newValues.produccionsuspencion = !e.target.checked
                                                        newValues.entregahologramasbebidasmezcal = e.target.checked
                                                        //newValues.certificadonomproductor = e.target.checked
                                                        setValues(newValues)
                                                    }}
                                                    onBlur={handleBlur} />
                                                <label className="form-check-label ms-3" htmlFor="flexCheckChecked">
                                                    Entrega de hologramas para bebidas con
                                                </label><br />
                                                <label className="ms-4">mezcal</label><br />
                                                <span className='text-danger'>{fc_41Map?.entregahologramasbebidasmezcalcheck === true ? fc_41Map?.entregahologramasbebidasmezcal : ''}</span>
                                            </div>
                                            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                <div className="form-floating mb-3">
                                                    <input type="date" className={`form-control ${fc_41Map.fechavisitapropuestacheck !== undefined ? (
                                                        fc_41Map?.fechavisitapropuestacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                        id="" placeholder='Fecha de termino' min={fechaHoy}
                                                        name="fechavisitapropuesta"
                                                        value={values.fechavisitapropuesta}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur} />
                                                    <label htmlFor='floatingInput'>Fecha de visita propuesta</label>
                                                    <span className='text-danger'>{fc_41Map?.fechavisitapropuestacheck ? fc_41Map?.fechavisitapropuesta : ''}</span>
                                                    {touched.fechavisitapropuesta && errors.fechavisitapropuesta && <div className="text-danger">{errors.fechavisitapropuesta}</div>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                                : paginaActiva === 2 ?
                                    <Fragment>
                                        <div className='row'>
                                            <h6 className={`text-center ${estilos.labelNaranja}`}>CARACTERÍSTICAS DEL PRODUCTO </h6>
                                        </div>
                                        <TablaProducto api={{ handdleProducto, handdleRemoveProductosPrev, handdleEditProductosPrev, productos }} marcas={marcas} productosMap={fc_41ProductosMap}></TablaProducto>
                                        {errors.productos && <div className="text-danger text-center">{errors.productos}</div>}

                                        {values.ventaexportacion &&
                                            <div className='row justify-content-start'>
                                                <div className='row'>
                                                    <h6 className={`text-center ${estilos.labelNaranja} mb-3`} title='Los datos deben
                                            aparecer tal cual se indican en la factura y orden de compra.'>INFORMACIÓN DEL IMPORTADOR
                                                    </h6>
                                                </div>

                                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <div className="form-floating mb-3">
                                                        <input type="text" className={`form-control ${fc_41Map.nombreimportadorcheck !== undefined ? (
                                                            fc_41Map?.nombreimportadorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            id="" placeholder='nombreimportador'
                                                            name="nombreimportador"
                                                            value={values.nombreimportador}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        <label htmlFor='floatingInput'>Nombre de importador</label>
                                                        <span className='text-danger'>{fc_41Map?.nombreimportadorcheck ? fc_41Map?.nombreimportador : ''}</span>
                                                        {touched.nombreimportador && errors.nombreimportador && <div className="text-danger">{errors.nombreimportador}</div>}
                                                    </div>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <div className="form-floating mb-3">
                                                        <input type="text" className={`form-control ${fc_41Map.domicilioimportadorcheck !== undefined ? (
                                                            fc_41Map?.domicilioimportadorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            id="" placeholder='domicilioimportador'
                                                            name="domicilioimportador"
                                                            value={values.domicilioimportador}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur} />
                                                        <label htmlFor='floatingInput'>Domicilio completo del importador</label>
                                                        <span className='text-danger'>{fc_41Map?.domicilioimportadorcheck ? fc_41Map?.domicilioimportador : ''}</span>
                                                        {touched.domicilioimportador && errors.domicilioimportador && <div className="text-danger">{errors.domicilioimportador}</div>}
                                                    </div>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <div className="form-floating mb-3">
                                                        <input type="text" className={`form-control ${fc_41Map.paisdestinocheck !== undefined ? (
                                                            fc_41Map?.paisdestinocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            id="" placeholder='paisdestino'
                                                            name="paisdestino"
                                                            value={values.paisdestino}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur} />
                                                        <label htmlFor='floatingInput'>Pais destino</label>
                                                        <span className='text-danger'>{fc_41Map?.paisdestinocheck ? fc_41Map?.paisdestino : ''}</span>
                                                        {touched.paisdestino && errors.paisdestino && <div className="text-danger">{errors.paisdestino}</div>}
                                                    </div>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xxl-6'>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-select ${fc_41Map.aduanasalidacheck !== undefined ? (
                                                            fc_41Map?.aduanasalidacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            value={values.aduanasalida}
                                                            name="aduanasalida"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur} >
                                                            <option value="0" >ADUANA SALIDA</option>
                                                            <option value="AEROPUERTO INTERNACIONAL DE LA CIUDAD DE MÉXICO">AEROPUERTO INTERNACIONAL DE LA CIUDAD DE MÉXICO</option>
                                                            <option value="AGUASCALIENTES, AGUASCALIENTES">AGUASCALIENTES, AGUASCALIENTES</option>
                                                            <option value="ALTAMIRA, TAMAULIPAS">ALTAMIRA, TAMAULIPAS</option>
                                                            <option value="CIUDAD HIDALGO, CHIAPAS">CIUDAD HIDALGO, CHIAPAS</option>
                                                            <option value="CIUDAD JUÁREZ, CHIHUAHUA">CIUDAD JUÁREZ, CHIHUAHUA</option>
                                                            <option value="COLOMBIA, NUEVO LEÓN">COLOMBIA, NUEVO LEÓN</option>
                                                            <option value="GUADALAJARA, JALISCO">GUADALAJARA, JALISCO</option>
                                                            <option value="GUANAJUATO, GUANAJUATO">GUANAJUATO, GUANAJUATO</option>
                                                            <option value="LÁZARO CÁRDENAS, MICHOACÁN">LÁZARO CÁRDENAS, MICHOACÁN</option>
                                                            <option value="MANZANILLO, COLIMA">MANZANILLO, COLIMA</option>
                                                            <option value="MEXICALI, BAJA CALIFORNIA">MEXICALI, BAJA CALIFORNIA</option>
                                                            <option value="MÉXICO, CIUDAD DE MÉXICO">MÉXICO, CIUDAD DE MÉXICO</option>
                                                            <option value="NOGALES, SONORA">NOGALES, SONORA</option>
                                                            <option value="NUEVO LAREDO, TAMAULIPAS">NUEVO LAREDO, TAMAULIPAS</option>
                                                            <option value="PIEDRAS NEGRAS, COAHUILA DE ZARAGOZA">PIEDRAS NEGRAS, COAHUILA DE ZARAGOZA</option>
                                                            <option value="TAMPICO, TAMAULIPAS">TAMPICO, TAMAULIPAS</option>
                                                            <option value="TIJUANA, BAJA CALIFORNIA">TIJUANA, BAJA CALIFORNIA</option>
                                                            <option value="TUXPAN, VERACRUZ">TUXPAN, VERACRUZ</option>
                                                            <option value="VERACRUZ, VERACRUZ">VERACRUZ, VERACRUZ</option>
                                                            <option value="PENDIENTE">PENDIENTE</option>
                                                        </select>
                                                        <label htmlFor='floatingInput'></label>
                                                        <span className='text-danger'>{fc_41Map?.aduanasalidacheck ? fc_41Map?.aduanasalida : ''}</span>
                                                        {touched.aduanasalida && errors.aduanasalida && <div className="text-danger">{errors.aduanasalida}</div>}
                                                    </div>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                    <div className="form-floating mb-3">
                                                        <input type="text" className={`form-control ${fc_41Map.observacionescheck !== undefined ? (
                                                            fc_41Map?.observacionescheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            id="" placeholder='observaciones'
                                                            name="observaciones"
                                                            value={values.observaciones}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur} />
                                                        <label htmlFor='floatingInput'>Observaciones</label>
                                                        <span className='text-danger'>{fc_41Map?.observacionescheck ? fc_41Map?.observaciones : ''}</span>
                                                        {touched.observaciones && errors.observaciones && <div className="text-danger">{errors.observaciones}</div>}
                                                    </div>
                                                </div>
                                            </div>
                                        }<br />
                                    </Fragment>
                                    :
                                    <Fragment>
                                        {modoCorreccion &&
                                            <div className={`row col-md-12`} style={{ marginLeft: '-9%' }}>
                                                <DocumentacionFC_41Component />
                                            </div>
                                        }
                                        <div className=" text-align: justify">
                                            <TerminosYCondicionesComponent terminosYCondiciones={terminosYCondiciones} formato={'fc_41'} />
                                        </div> <br /> <br />
                                        {!modoCorreccion ?
                                            <div>
                                                <div className="row mt-4">
                                                    {modoEdicionBorrador ?
                                                        <div className="d-grid gap-2 col-2 mx-auto">
                                                            <button type="submit"
                                                                onClick={() => { botonEnviarSolicitudBorradorFC_41(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                className={`btn ${estilos.botonNaranjaRedondo}`}
                                                            >Enviar borrador</button>
                                                        </div> :
                                                        <div className="d-grid gap-2 col-2 mx-auto">
                                                            <button type="submit"
                                                                onClick={() => { botonEnviarSolicitudFC_41(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                disabled={!terminosYCondiciones}>Enviar</button>
                                                        </div>
                                                    }
                                                </div>
                                            </div> :
                                            <div className="row mt-4">
                                                <div className="d-grid gap-2 col-2 mx-auto">
                                                    <button type="submit"
                                                        onClick={() => { botonEnviarCorreccionesFC_41(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                        className={`btn ${estilos.botonNaranjaRedondo}`} disabled={!terminosYCondiciones}>Enviar correcciones</button>
                                                </div>
                                            </div>
                                        }
                                    </Fragment>
                            }<br />
                            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
                            <BotonAtrasSiguienteComponent botonSiguiente={paginaSiguiente} botonAnterior={paginaAnterior} paginaActiva={paginaActiva} totalDePaginas={paginas.length} valores={values} />
                            {modalComponent()}
                        </div>
                    </form>
                )}
            </Formik>
        </Fragment >
    )
}
export default withRouter(FormularioFC41BeneficiarioComponent)